import TestUserActionTypes from "./testUserActionTypes"
import { Subsidies } from "#/lib/carrot-api/types/Subsidy"

export const toggleDymamicContentTogglesTool = () => async (dispatch: any) => {
  dispatch({
    type: TestUserActionTypes.TOGGLE_DYNAMIC_CONTENT_TOGGLES_TOOL,
    response: {}
  })
}

export const toggleSubsidiesOverride = (subsidies: Subsidies) => async (dispatch: any) => {
  dispatch({
    type: TestUserActionTypes.TOGGLE_SUBSIDIES_OVERRIDE,
    response: subsidies
  })
}
